import { generateClassName } from '@klv/shared/utils/functions';

import * as s from './styles/unified-search-result-list-item.module.css';

import type { IUnifiedSearchResult } from '@klv/molecules/unified-search-results/types';

const UnifiedSearchResultListItem = ({
  description = '',
  link,
  metadata = '',
  parentBackgroundColor,
  sendEvent,
  title,
  match,
  body,
}: IUnifiedSearchResult) => {

  const previewText = match === 'none' && body ? body : description;

  return (
    <div className={s.searchResult}>
      <a
        className={generateClassName([s.title, 'p1'])}
        href={link}
        dangerouslySetInnerHTML={{ __html: title }} 
        onClick={sendEvent}
      />
      {!!previewText && 
        <div
          className={generateClassName([s.description, 'p2'])}
          dangerouslySetInnerHTML={{ __html: previewText }}
        />
      }
      {!!metadata && <div className="p3">{metadata}</div>}
    </div>
  );
};

export default UnifiedSearchResultListItem;
